module.exports = __webpack_public_path__ + "img/cross.008a15bd.png";